export default __webpack_public_path__ + "static/media/7070BLEU.e4106840.pdf";